import React, { useState, useEffect } from 'react';
import './styles.scss';
import lib from '../../../../../src/helpers/lib';
import Skeleton from 'react-loading-skeleton';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faBolt,
  faBullseye,
  faChartBar,
  faCircleCheck,
  faMoneyBillWaveAlt
} from '@fortawesome/free-solid-svg-icons';

export default function CardPanel({ source, isLoading = false }) {
  const [cardData, setCardData] = useState(null);

  useEffect(() => {
    let metaContratante = source;
    if (!metaContratante?.dias) return;

    let ultimoDia = metaContratante.dias.pop();

    let pedidos = ultimoDia.valor;
    let vendas = ultimoDia.valorFaturado;
    let meta = ultimoDia.meta;

    let objetivo,
      metaFaltante = 0;

    if (meta > 0) {
      objetivo = Math.round((pedidos / meta) * 100 * 100) / 100;
      metaFaltante = meta - pedidos;
    }

    setCardData({
      pedidos: pedidos,
      vendas: vendas,
      meta: meta,
      objetivo: objetivo,
      metaFaltante: metaFaltante
    });
  }, [source]);

  // if (!cardData) return null;

  return (
    <div className="container-fluid big-number">
      <div className="d-sm-flex align-items-center justify-content-between mb-4"></div>
      <div className="row d-flex">
        {/* Card 1 */}
        <div className="col mb-4">
          {/* CORREÇÃO 1: Estrutura simplificada e classe h-100 para altura igual */}
          <div className="card bg-secondary shadow h-100 py-2">
            {/* CORREÇÃO 2: Classes flex para centralizar o conteúdo verticalmente */}
            <div className="card-body d-flex flex-column justify-content-center">
              <div className="row no-gutters align-items-center text-white">
                <div className="col mr-2">
                  <div className="font-weight-bold mb-1">
                    <span style={{ fontWeight: '700' }} className="text-uppercase">
                      <FontAwesomeIcon icon={faBolt} />
                      Pedidos no Mês
                    </span>
                  </div>
                  <div className="h3 mb-0">
                    {!isLoading ? (
                      Math.floor(cardData?.pedidos)?.toLocaleString('pt-br', {
                        style: 'currency',
                        currency: 'BRL',
                        maximumFractionDigits: 0
                      })
                    ) : (
                      <Skeleton count={1} />
                    )}
                  </div>
                </div>
                <div className="col-auto">
                  <i className="fas fa-calendar fa-2x text-gray-300"></i>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Card 2 */}
        <div className="col mb-4">
          <div className="card bg-custom-gray shadow h-100 py-2">
            <div className="card-body d-flex flex-column justify-content-center text-white">
              <div className="row no-gutters align-items-center">
                <div className="col mr-2">
                  <div className="mb-1">
                    <span style={{ fontWeight: '700' }} className="text-uppercase">
                      <FontAwesomeIcon icon={faMoneyBillWaveAlt} />
                      FATURADO NO MÊS
                    </span>
                  </div>
                  <div className="h3 mb-0">
                    {!isLoading ? (
                      Math.floor(cardData?.vendas)?.toLocaleString('pt-br', {
                        style: 'currency',
                        currency: 'BRL',
                        maximumFractionDigits: 0
                      })
                    ) : (
                      <Skeleton count={1} />
                    )}
                  </div>
                </div>
                <div className="col-auto">
                  <i className="fas fa-dollar-sign fa-2x text-gray-300"></i>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Card 3 */}
        <div className="col mb-4">
          <div className="card bg-secondary text-white shadow h-100 py-2">
            <div className="card-body d-flex flex-column justify-content-center">
              <div className="row no-gutters align-items-center">
                <div className="col mr-2">
                  <div className="font-weight-bold mb-1">
                    <span style={{ fontWeight: '700' }} className="text-uppercase">
                      <FontAwesomeIcon icon={faBullseye} />
                      Objetivo no Mês
                    </span>
                  </div>
                  <div className="h3 mb-0">
                    {!isLoading ? (
                      Math.floor(cardData?.meta)?.toLocaleString('pt-br', {
                        style: 'currency',
                        currency: 'BRL',
                        maximumFractionDigits: 0
                      })
                    ) : (
                      <Skeleton count={1} />
                    )}
                  </div>
                </div>
                <div className="col-auto">
                  <i className="fas fa-dollar-sign fa-2x text-gray-300"></i>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Card 4 */}
        <div className="col mb-4">
          <div className="card bg-custom-gray text-white shadow h-100 py-2">
            <div className="card-body d-flex flex-column justify-content-center">
              <div className="row no-gutters align-items-center">
                <div className="col mr-2">
                  <div className="font-weight-bold mb-1">
                    <span style={{ fontWeight: '700' }} className="text-uppercase">
                      <FontAwesomeIcon icon={faCircleCheck} />
                      Objetivo Realizado
                    </span>
                  </div>
                  <div className="row no-gutters align-items-center">
                    <div className="col-auto">
                      <div className="h3 mb-0 mr-3 font-weight-bold">
                        {!isLoading ? (
                          // (
                          // cardData?.objetivo > 0 ? (
                          //   `${cardData.objetivo}%`
                          // ) : (
                          //   '0%'
                          // )
                          lib.formatToNumeric(
                            cardData.objetivo > 0 ? cardData.objetivo : 0,
                            2,
                            true
                          ) + '%'
                        ) : (
                          <Skeleton count={1} />
                        )}
                      </div>
                    </div>
                    <div className="col">
                      {!isLoading ? (
                        <div className="progress progress-sm mr-2">
                          <div
                            className="progress-bar bg-primary"
                            role="progressbar"
                            style={{ width: `${cardData?.objetivo}%` }}
                            aria-valuenow={cardData?.objetivo}
                            aria-valuemin="0"
                            aria-valuemax="100"
                          />
                        </div>
                      ) : (
                        <Skeleton count={1} />
                      )}
                    </div>
                  </div>
                </div>
                <div className="col-auto">
                  <i className="fas fa-clipboard-list fa-2x text-gray-300"></i>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Card 5 */}
        <div className="col mb-4">
          <div className="card bg-secondary text-white shadow h-100 py-2">
            <div className="card-body d-flex flex-column justify-content-center">
              <div className="row no-gutters align-items-center">
                <div className="col mr-2">
                  <div className="font-weight-bold mb-1">
                    <span style={{ fontWeight: '700' }} className="text-uppercase">
                      <FontAwesomeIcon icon={faChartBar} />
                      Objetivo Faltante
                    </span>
                  </div>
                  <div className="h3 mb-0">
                    {!isLoading ? (
                      Math.floor(cardData?.metaFaltante)?.toLocaleString('pt-br', {
                        style: 'currency',
                        currency: 'BRL',
                        maximumFractionDigits: 0
                      })
                    ) : (
                      <Skeleton count={1} />
                    )}
                  </div>
                </div>
                <div className="col-auto">
                  <i className="fas fa-comments fa-2x text-gray-300"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
